/**
 * @file: reservationListConstants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Static option tables for the reservation-list controls (status tabs, sort
 * orders). Kept separate from the controls hook so both the hook and the
 * presentational chips/sheets read from one source of truth.
 */

import { ReservationStatus } from '@euler/model/reservation/Reservation';
import { ReservationSorter } from '@euler/model/reservation/types';

export type ReservationStatusTab = {
  key: string;
  label: string;
  status?: ReservationStatus[];
};

// The status filter tabs. The "all" tab clears the status filter; the rest map a tab to
// the underlying reservation statuses it groups.
export const kReservationStatusTabs: ReservationStatusTab[] = [
  { key: 'all', label: '全部' },
  { key: 'upcoming', label: '待到店', status: ['pending', 'confirmed'] },
  { key: 'arrived', label: '已到店', status: ['arrived'] },
  { key: 'converted', label: '已开单', status: ['converted'] },
  { key: 'closed', label: '已结束', status: ['cancelled', 'no_show'] },
];

export type ReservationSortOption = {
  key: string;
  label: string;
  sorter: ReservationSorter;
};

// The first option is the list default — newest bookings first.
export const kReservationSortOptions: ReservationSortOption[] = [
  {
    key: 'createdDesc',
    label: '创建时间',
    sorter: { prop: 'createdAt', dir: 'desc' },
  },
  {
    key: 'arrivalAsc',
    label: '到店时间',
    sorter: { prop: 'expectedArrivalAt', dir: 'asc' },
  },
];
